import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import {UserInfoDto} from "../pages/user-list/models/user-models";
import {UserDataService} from "../pages/user-list/services/user-data.service";
import {NotificationDataService} from "../pages/notifications/services/notification-data.service";

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

  userInfo$: Subject<UserInfoDto> = new Subject<UserInfoDto>()
  userId$: Subject<number | undefined> = new BehaviorSubject<number | undefined>(undefined)
  agentId$: Subject<string | undefined> = new BehaviorSubject<string | undefined>(undefined)


  userNotificationCount$: Subject<string> = new Subject<string>()

  constructor(
    // private userDataService: UserDataService,
    // private notificationDataService: NotificationDataService
  ) { }

  // getUserInfo() {
  //   const userId = localStorage.getItem('user_id') ?? ''
  //   this.userDataService.loadUserInfo(+userId).subscribe({
  //     next: (res) => {
  //       this.userInfo$.next(res)
  //     }
  //   })
  // }
  //
  // getNotificationCount() {
  //   this.notificationDataService.loadCount().subscribe({
  //     next: (res) => {
  //       this.userNotificationCount$.next(res.unread_count)
  //     }
  //   })
  // }

}
